import React, { useState, useEffect } from 'react';
import lodash from 'lodash';
import { Link, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { expiredPassword, loginError, loginShowExpiredPassword, setLoginEmailError, setPasswordResetEmailSent, showPasswordInput, ssoSettingPin } from '../../actions/login';
import LoginLayout from './LoginLayout';
import styles from './Login.scss';
import PasswordValidation from './PasswordValidation';
import { checkValidPassword } from './CheckValidPassword';

const ExpiredPassword = (props) => {
    const { showPasswordInput, loginErrorState, loginShowExpiredPassword, setPasswordResetEmailSent, location, expiredPassword } = props;

    const [email, setEmail] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [currentPassword, setCurrentPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [newPasswordError, setNewPasswordError] = useState('');
    const [currentPasswordType, setCurrentPasswordType] = useState(true);
    const [newPasswordType, setNewPasswordType] = useState(true);
    const [validPassword, setValidPassword] = useState(false);
    useEffect(() => {
        setPasswordResetEmailSent(false);
        showPasswordInput(false);
    }, [showPasswordInput]);

    useEffect(() => {
        if (!location.state) {
            loginShowExpiredPassword(false);
            window.location.href = '/';
        }
        else {
            setEmail(location.state.email);
        }
    }, [location.state]);

    const onSubmitClick = async (e) => {
        e.preventDefault();

        const isCurrentPasswordEmpty = currentPassword === '';
        const isNewPasswordEmpty = newPassword === '';
        const isNewPasswordInvalid = !validPassword || !checkValidPassword(newPassword);

        setPasswordError(isCurrentPasswordEmpty ? 'Please enter your current password.' : '');
        setNewPasswordError(isNewPasswordEmpty ? 'Please enter a valid password.' : '');

        if (isCurrentPasswordEmpty || isNewPasswordEmpty) {
            if (isCurrentPasswordEmpty && !isNewPasswordEmpty && isNewPasswordInvalid) {
                setNewPasswordError('This password does not meet our requirements.');
            }
            return;
        }

        if (isNewPasswordInvalid) {
            setNewPasswordError('This password does not meet our requirements.');
            return;
        }

        if (currentPassword && newPassword && validPassword) {
            const expiredPasswordResponse = await expiredPassword({ currentPassword, newPassword, email });
            if (expiredPasswordResponse.error) {
                if (expiredPasswordResponse.error === 'The password could not be changed.') {
                    setPasswordError('This password is incorrect. Please try again.');
                    setNewPasswordError('');
                }
                else {
                    setPasswordError('');
                    setNewPasswordError(expiredPasswordResponse.error.replace('Validation error: ', ''));
                }
            }
        }
    };



    return (
        <LoginLayout>
            <div className={styles.complionTitle}>
                Password expired
                <div className={styles.caption}>
                    Please set a new password.
                </div>
            </div>

            <form autoComplete="off" className={styles.form} onSubmit={(e) => onSubmitClick(e)} noValidate>
                <div className={styles.inputContainer}>
                    <div className={styles.formGroup}>
                        <div className={styles.labelGroup}>
                            <label htmlFor="old-password" className={styles.inputLabelv4}>
                                Current Password
                            </label>
                        </div>

                        <label className={`${styles.passowordInput} ${passwordError && styles.passowordInputError}`}>
                            <input
                                id="old-password"
                                type={currentPasswordType ? 'password' : 'text'}
                                name="currentPassword"
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                autoFocus
                            />
                            <FontAwesomeIcon
                                icon={currentPasswordType ? faEye : faEyeSlash}
                                className={styles.passwordIcon}
                                onClick={() =>
                                    setCurrentPasswordType(!currentPasswordType)
                                }
                            />
                        </label>
                        {passwordError && <span className={styles.errorv4}>{passwordError}</span>}
                        {props.loginEmailError && <span className={styles.errorv4}>{props.loginEmailError} </span>}
                        <div> <Link to={{ pathname: '/forgot-password', state: { email } }} className={styles.forgotPasswordV4}>Forgot Password?</Link></div>
                    </div>
                    <div className={styles.formGroup}>
                        <div className={styles.labelGroup}>
                            <label htmlFor="password" className={styles.inputLabelv4}>
                                New Password
                            </label>
                        </div>
                        <label className={`${styles.passowordInput} ${newPasswordError && styles.passowordInputError}`}>
                            <input
                                id="new-password"
                                type={newPasswordType ? 'password' : 'text'}
                                name="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <FontAwesomeIcon
                                icon={newPasswordType ? faEye : faEyeSlash}
                                className={styles.passwordIcon}
                                onClick={() =>
                                    setNewPasswordType(!newPasswordType)
                                }
                            />
                        </label>
                        {newPasswordError && <span className={styles.errorv4}>{newPasswordError}</span>}

                        <PasswordValidation password={newPassword} setValidPassword={setValidPassword} />
                    </div>
                </div>
                {loginErrorState && <span className={styles.errorv4}>{loginErrorState}</span>}

                <div className={styles.formGroup}>
                    <button type="submit" className={styles.actionButtonv4} >
                        Change Password
                    </button>
                </div>
            </form >
        </LoginLayout >
    );
};

const mapStateToProps = (state) => ({
    clientData: lodash.get(state, 'application.config', {}),
    loginErrorState: lodash.get(state, 'loginError', false),
    loginEmailError: lodash.get(state, 'loginEmailError', false),
    showExpierPassword: lodash.get(state, 'showPassword', false),
});

export default connect(mapStateToProps, { setLoginEmailError, showPasswordInput, ssoSettingPin, loginError, setPasswordResetEmailSent, loginShowExpiredPassword, expiredPassword })(withRouter(ExpiredPassword));
